import { render, staticRenderFns } from "./LanguageStats.vue?vue&type=template&id=b89963d4&scoped=true&"
import script from "./LanguageStats.vue?vue&type=script&lang=js&"
export * from "./LanguageStats.vue?vue&type=script&lang=js&"
import style0 from "./LanguageStats.vue?vue&type=style&index=0&id=b89963d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89963d4",
  null
  
)

export default component.exports